import { render, staticRenderFns } from "./idpLayout.vue?vue&type=template&id=4ce71487&scoped=true"
import script from "./idpLayout.vue?vue&type=script&lang=js"
export * from "./idpLayout.vue?vue&type=script&lang=js"
import style0 from "./idpLayout.vue?vue&type=style&index=0&id=4ce71487&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce71487",
  null
  
)

export default component.exports